import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import { PauseIcon } from "@heroicons/react/24/outline";
import { ButtonDummy } from "../../index.tsx";
import { Column } from "@tanstack/react-table";
import { useState } from "react";

type ToggleColumnDropdownProps = {
  icon: React.ReactNode;
  options: Column<any, unknown>[];
  headText: string;
  className?: string;
  setColumnOrder: (data: string[]) => void;
};

function ToggleColumnDropdown({
  icon,
  options,
  headText,
  className,
  setColumnOrder,
}: ToggleColumnDropdownProps) {
  const [draggedIndex, setDraggedIndex] = useState<number>();

  const handleOnDragStart = (index: number) => {
    setDraggedIndex(index);
  };

  const handleOnDragOver = (e: any) => {
    e.preventDefault();
  };

  const handleOnDrop = (index: number) => {
    const updatedColumns = options;
    const [draggedItem] = updatedColumns.splice(draggedIndex as number, 1);

    updatedColumns.splice(index, 0, draggedItem);
    const columnIds = updatedColumns.map((columnUnit) => columnUnit.id);
    setColumnOrder(columnIds);
  };

  return (
    <Popover as="div" className="relative">
      <PopoverButton as={ButtonDummy} icon={icon} className={className} />

      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-100 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <PopoverPanel className="z-30 absolute right-[110%] shadow-xl shadow-extraLightGray min-w-max  bg-white  border border-extraLightGray/60 rounded-lg">
          <p className="px-4 py-2 text-sm text-subHeading  font-semibold">
            {headText}
          </p>
          <section>
            {options.map((column, index) => {
              if (typeof column?.columnDef?.header === "function") return <></>;
              return (
                <div
                  key={column.id}
                  className="h-9 px-4 flex items-center justify-between gap-2 border-t border-extraLightGray/60 cursor-grab"
                  draggable
                  onDragStart={() => handleOnDragStart(index)}
                  onDragOver={handleOnDragOver}
                  onDrop={() => handleOnDrop(index)}
                >
                  <div className="flex items-center gap-2">
                    <input
                      className="h-4 w-4"
                      type="checkbox"
                      checked={column.getIsVisible()}
                      onChange={column.getToggleVisibilityHandler()}
                    />
                    <span className="text-xs font-semibold text-body capitalize ">
                      {String(column?.columnDef?.header)}
                    </span>
                  </div>
                  <PauseIcon className="size-4" />
                </div>
              );
            })}
          </section>
        </PopoverPanel>
      </Transition>
    </Popover>
  );
}

export default ToggleColumnDropdown;
